
import RuleNav from '~/components/about/rule-nav.vue'
export default {
  //  抽奖管理规范页面
  name: 'Drawrule',
  components: { RuleNav },
  layout: 'template-page',
  head() {
    return {
      title: '抽奖管理规范_问卷网',
    }
  },
}
